import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useUserData } from "hooks/UserContext";

export default function FlightResume() {
  const location = useLocation();
  const { user } = useUserData();

  const [iframeUrl, setIframeUrl] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      const baseUrl = process.env.REACT_APP_MONOLITO_URL;

      if (!baseUrl) {
        setError("URL base não configurada.");
        return;
      }

      const balance = user?.balance?.data ?? 0;

      const searchParams = new URLSearchParams(location.search);

      if (balance) {
        searchParams.set("balance", balance);
      }

      const channel = process.env.REACT_APP_DEFAULT_CHANNEL;
      const fullUrl = `${baseUrl}/${channel}/passagens-aereas/voos?${searchParams.toString()}`;

      setIframeUrl(fullUrl);

    } catch (err) {
      console.error("Erro ao montar iframe:", err);
      setError("Erro interno ao carregar o conteúdo.");
    }
  }, [location, user]);

  if (error) {
    return (
      <div style={{ textAlign: "center", marginTop: "100px", color: "red" }}>
        {error}
      </div>
    );
  }

  if (!iframeUrl) {
    return (
      <p style={{ textAlign: "center", marginTop: "100px" }}>
        Carregando...
      </p>
    );
  }

  return (
    <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      <iframe
        src={iframeUrl}
        title="Flight Resume"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          overflow: "hidden",
          marginTop: "35%"
        }}
      />
    </div>
  );
}